import '~app/sentry';

import '~shared/telemetry';

import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';

import { PortalQueryClientProvider } from '~app/providers';
import { router } from '~app/router';

import { AuthApiProvider, getUserAmpliProps } from '~platform/auth';

import { initAmpli } from '~shared/analytics';
import { config } from '~shared/config';
import { growthBookInstance } from '~shared/growthbook';
import { getAwsWafDomains } from '~shared/lib/aws-waf';
import { ConfirmationProvider } from '~shared/ui/confirmation';

import * as Sentry from '@breeze/web-lib-sentry';
import { Toaster } from '@breezeventures/ui-kit/toast';
import { initAwsWaf } from '@breezeventures/web-ph-aws-waf-tools/init-aws-waf';
import { GrowthBookProvider } from '@growthbook/growthbook-react';

import './globals.css';

if (config.environment !== 'local') {
  initAwsWaf({
    cookieDomainList: getAwsWafDomains(),
    env: config.environment === 'prod' ? 'prod' : 'test',
  });
}

initAmpli(getUserAmpliProps);

const root = document.getElementById('root') as HTMLElement;

// window.msw = {
//   ...(window.msw ?? {}),
//   initialHandlersOverrides: {
//     getPermissions: {
//       payload: { permissions: ['ORDERS_VIEW'] },
//     },
//     // checkPartnerSelfie: {
//     //   scenario: 'no-selfie',
//     // },
//     // getPartnerApplicationsByPerson: {
//     //   payload: [],
//     // },
//   },
// };

const enableMocking = config.isMockingEnabled || !!window.TURN_ON_MSW;

const startMocking = enableMocking
  ? async () => {
      const [{ handlers }, { setupMocking }] = await Promise.all([
        import('./mocks'),
        import('@breezeventures/msw-kit'),
      ]);
      return setupMocking({ enabled: true, handlers });
    }
  : () => Promise.resolve();

startMocking()
  .then(() => {
    ReactDOM.createRoot(root).render(
      // <React.StrictMode>
      <GrowthBookProvider growthbook={growthBookInstance}>
        <ConfirmationProvider>
          <Toaster position="top-right" />
          <AuthApiProvider>
            <PortalQueryClientProvider>
              <Sentry.ErrorBoundary fallback={<div>Something went wrong</div>}>
                <RouterProvider router={router} />
              </Sentry.ErrorBoundary>
            </PortalQueryClientProvider>
          </AuthApiProvider>
        </ConfirmationProvider>
      </GrowthBookProvider>
      // </React.StrictMode>
    );
  })
  .catch(() => {
    // Error handling
  });
